import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 1.2rem;
`;

export const Title = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Progress = styled.small`
  display: block;
  margin-bottom: 0.75rem;
  color: #595959;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e8e8e8;

  &:last-child {
    border-bottom: none;
  }
`;

export const ItemTitle = styled.span`
  font-weight: 600;
`;

export const ItemDescription = styled.small`
  color: #8c8c8c;
  display: block;
  margin-left: 1.5rem;
`;
